// test1589
(1589 && 0);
